module.exports = __webpack_public_path__ + "img/dummyprod10@1x.dc224800.png";